import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { ReactComponent as SentenciasIcon } from '../sentencias.svg'
import { ReactComponent as ViolenciaIcon } from '../familiar.svg'
import { ReactComponent as AlimentosIcon } from '../alimentos.svg'
import Container from '@material-ui/core/Container'
//import MenuItem from '@material-ui/core/MenuItem'
//import FormControl from '@material-ui/core/FormControl'
//import TextField from '@material-ui/core/TextField'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'

const useStyles = makeStyles(theme => ({
  /*pos1: {
		width: 35,
		fontSize: 20,
		marginRight: 10
	},
	pos2: {
		width: 50,
		fontSize: 20,
		marginRight: 10
	},*/
  title: {
    fontSize: 15,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 400,
    minHeight: 60
  },
  pos1: {
    width: 45,
    fontSize: 20,
    marginRight: 10
  },
  pos2: {
    width: 70,
    fontSize: 20,
    marginRight: 10
  },
  formControl: {
    margin: theme.spacing(1),
    maxWidth: 620,
    width: '100%'
  },
  menulist: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  menuitem: {
    justifyContent: 'center',
    minHeight: 60
  },
  underline: {
    '& ::before': {
      borderBottom: '1px solid rgb(1, 175, 150)'
    }
  },
  label: {
    color: theme.palette.primary.main
  },
  card: {
    minWidth: 200,
    width: '100%',
    textAlign: 'center',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0px 0px 3px 2px rgba(5, 130, 112, 0.46)'
    },
    [theme.breakpoints.down('md')]: {
      minWidth: 100
		},
		margin: 5
  },
  cardSelected: {
    minWidth: 200,
    width: '100%',
    textAlign: 'center',
    cursor: 'pointer',
    boxShadow: '0px 0px 3px 2px rgba(5, 130, 112, 0.46)',
    [theme.breakpoints.down('md')]: {
      minWidth: 100
		},
		margin: 5
	},
	cardContainer: {
		display: 'flex',
		[theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap'
		}
	}
}))

export default function CardOption({ handleSelect, selected }) {
  const classes = useStyles()

  return (
    <Container
      style={{
        margin: '4em auto',
        maxWidth: 800,
        textAlign: 'center',
        padding: 0
      }}
    >
      {/*<FormControl className={classes.formControl}>
				<TextField
          id="outlined-select-currency"
          select
          label="Seleccionar tipo de sentencia"
          value={selected}
          onChange={handleSelect}
					variant="outlined"
					SelectProps={{
						classes: {
							root: classes.menulist
						}
					}}
        >
					<MenuItem classes={{ root: classes.menuitem }} value='penales'>
						<div className={classes.pos1}>
							<SentenciasIcon />
						</div>{' '}
						Candidatos con sentencias penales
					</MenuItem>
					<MenuItem classes={{ root: classes.menuitem }} value='violencia'>
						<div className={classes.pos2}>
							<ViolenciaIcon />
						</div>{' '}
						Candidatos con sentencias por violencia familiar
					</MenuItem>
					<MenuItem classes={{ root: classes.menuitem }} value='alimentos'>
						<div className={classes.pos1}>
							<AlimentosIcon />
						</div>{' '}
						Candidatos con demandas fundadas por alimentos
					</MenuItem>
				</TextField>
				</FormControl>*/}
      <div className={classes.cardContainer}>
        <Card
          className={
            selected === 'penales' ? classes.cardSelected : classes.card
          }
          onClick={() => handleSelect('penales')}
        >
          <CardContent style={{ paddingBottom: 16 }}>
            <div className={classes.title}>
              <div className={classes.pos1}>
                <SentenciasIcon />
              </div>
              <div>Candidatos con sentencias penales</div>
            </div>
          </CardContent>
        </Card>
        <Card
          className={
            selected === 'violencia' ? classes.cardSelected : classes.card
          }
          onClick={() => handleSelect('violencia')}
        >
          <CardContent style={{ paddingBottom: 16 }}>
            <div className={classes.title}>
              <div className={classes.pos2}>
                <ViolenciaIcon />
              </div>
              <div>Candidatos con sentencias por violencia familiar</div>
            </div>
          </CardContent>
        </Card>
        <Card
          className={
            selected === 'alimentos' ? classes.cardSelected : classes.card
          }
          onClick={() => handleSelect('alimentos')}
        >
          <CardContent style={{ paddingBottom: 16 }}>
            <div className={classes.title}>
              <div className={classes.pos2}>
                <AlimentosIcon />
              </div>
              <div>Candidatos con demandas fundadas por alimentos</div>
            </div>
          </CardContent>
        </Card>
      </div>
    </Container>
  )
}
